class permissions {
    constructor(rolId, rolName, rolPermission) {
        this.rolId = rolId;
        this.rolName = rolName;
        this.rolPermission =rolPermission;
        
    }
    static fromJson({
        rolId,
        rolNombre,
        rolPermiso
    }) {
        return new permissions(
            rolId,
            rolNombre,
            rolPermiso
        );
    }
}
export default permissions;
